import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=3bfebe7c&"
import script from "./DefaultLayout.vue?vue&type=script&lang=js&"
export * from "./DefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QLayout,QHeader,QToolbar,QToolbarTitle,QPageContainer,QPage,QStepper,QStep,QFooter} from 'quasar'
component.options.components = Object.assign({QLayout,QHeader,QToolbar,QToolbarTitle,QPageContainer,QPage,QStepper,QStep,QFooter}, component.options.components || {})
